// Header dockning
let lastScrollTop = 0;
const body = document.body;
window.addEventListener('scroll', function () {
  const pageHeader = document.querySelector('.page-header');

  let scrollTop = window.scrollY || document
    .documentElement.scrollTop;

  if (scrollTop <= 0) {
    body.classList.add('show');
    pageHeader.classList.add('transparent');
    body.classList.remove('hide');
  } else {
    pageHeader.classList.remove('transparent');
    if (scrollTop > lastScrollTop) {
      body.classList.add('hide');
      body.classList.remove('show');
    } else {
      body.classList.add('show');
      body.classList.remove('hide');
    }
  }
  lastScrollTop = scrollTop;
});

// if mega menu is active on mobile
function checkActiveMenu() {
  const toggleMobile = document.querySelector('.gw-mm__toggle');
  const body = document.body || document.getElementsByTagName['body'][0];

  toggleMobile.addEventListener('click', function (e) {
    body.classList.toggle('overflow');
  });
}

// Mobile menu click
function mobileMenu() {
  const menuItem = document.querySelector('.page-header .wp-block-navigation-item__label');
  const html = document.querySelector('html');
  const mobileNav = document.querySelector('.wp-block-navigation__responsive-container');

  menuItem && menuItem?.addEventListener('click', () => {
    html.classList.remove('has-modal-open');
    mobileNav.classList.remove('is-menu-open', 'has-modal-open');
  }, false);

}

document.addEventListener('DOMContentLoaded', () => {
  mobileMenu();
  checkActiveMenu();
})

// Share buttons
window.addEventListener("load", (event) => {
  const btnShareLinkedIn = document.querySelector('.btn-share-linkedin a');
  const url = window.location.href;

  if ( btnShareLinkedIn ) {

    btnShareLinkedIn.addEventListener( 'click', ( e ) => {
      e.preventDefault();
    });

    let s = document.createElement('script');
    s.setAttribute('type', 'IN/Share');
    s.setAttribute('data-url', url);
    document.querySelector('.btn-share-linkedin a').appendChild(s);
  }

  const btnShareTwitter = document.querySelector('.btn-share-twitter a');
  if ( btnShareTwitter ) {
    btnShareTwitter.setAttribute('href', 'https://twitter.com/share?url=' + url);
  }

  const btnShareFacebook = document.querySelector('.btn-share-facebook a');
  if ( btnShareFacebook ) {

    btnShareFacebook.addEventListener( 'click', ( e ) => {
      e.preventDefault();
    });

    let iDiv = document.createElement('div');
    iDiv.className = 'fb-share-button';
    iDiv.setAttribute('data-href', url);
    iDiv.setAttribute('data-layout', 'icon_link');
    btnShareFacebook.appendChild(iDiv);
  }
});

